/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPackage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22h-.3c-.1 0-.1 0-.2-.1h-.1l-8-5c-.2-.2-.4-.6-.4-.9V7.7c0-.1 0-.1.1-.2 0-.1.1-.2.2-.2l.2-.2 4-2.5 4-2.5c.3-.2.7-.2 1.1 0l8 5c.1 0 .1.1.2.2l.2.2c0 .1.1.1.1.2V16c0 .3-.2.7-.5.8l-8 5h-.1c-.1 0-.1.1-.2.1-.1.1-.2.1-.3.1zm1-8.4v5.6l6-3.8V9.8l-2.5 1.5zm-8 1.8 6 3.8v-5.6L5 9.8zM5.9 8l6.1 3.8 2.1-1.3L8 6.7zm4-2.5L16 9.3 18.1 8 12 4.2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgPackage as Package };
